/**
 * Mise à jour du frontend : le backend lit le build.json servi par nginx toutes les minutes
 * (backend/services/frontendUpdateService.js) et diffuse FRONTEND_UPDATE ; à sa réception (boot/appUpdate.js),
 * le service worker cherche la nouvelle version, qui s'active et recharge les pages ouvertes.
 */
class AppUpdateService {

  // Build (commit git) de l'interface, fixé au build (quasar.config.js)
  get frontBuild() {
    return process.env.APP_BUILD || '';
  }

  /** Nouveau build déployé : vérification immédiate par le service worker (sans effet hors PWA) */
  checkForUpdate(commit) {
    if (!commit || commit === process.env.APP_BUILD || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.getRegistration()
      .then((registration) => registration && registration.update())
      .catch(() => {});
  }
}

export default new AppUpdateService();
